<template>
    <div class="proposition">
        <div class="title">
            <Heading size="s" weight="regular">
                {{ content.instagramIsBroken }}
            </Heading>
            <Heading :h="2" size="xl">
                {{ content.letsFixIt }}
            </Heading>
        </div>
        <div class="buttons">
            <Button class="browseButton"
                appearance="secondary"
                size="fullWidth"
                @click="$emit('changeView')">
                {{ content.startBrowsing }}
            </Button>
            <Button
                size="fullWidth"
                @click="$emit('openWaitlistModal')">
                {{ content.joinTheWaitlist }}
            </Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Proposition',
        props: {
            content: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .proposition {
        display: flex;
        flex-direction: column;
        max-width: 32rem;
        width: 100%;
    }

    .title {
        padding-top: 2rem;
    }

    .h1, .h2 {
        margin-top: 0;
        text-align: center;
    }

    .h1 {
        margin-bottom: 0.5rem;
        opacity: 0.8;
    }

    .buttons {
        display: flex;
        width: 100%;
    }

    .browseButton {
        margin-right: 1rem;
    }
</style>